import type { SubscriptionPlanOption } from '@/types/billing';

export function formatMinorUnits(amountMinor: number, currency: string): string {
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  });
  const fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
  return formatter.format(amountMinor / 10 ** fractionDigits);
}

export function formatBillingInterval(plan: SubscriptionPlanOption): string {
  const unit = plan.interval_count === 1 ? plan.interval_unit : `${plan.interval_unit}s`;
  return plan.interval_count === 1 ? `per ${unit}` : `every ${plan.interval_count} ${unit}`;
}

export function formatBillingDate(value: string | null): string {
  if (!value) return 'Not available';
  return new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(value));
}

export function formatUsage(value: string): string {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return value;
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(parsed);
}
